module.exports = __webpack_public_path__ + "img/facebook.76a84345.svg";